import './ccf-call-mute-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCallMuteIconProps extends SvgIconProps{}

/**
 * Component displays call mute  svg icon 
 * @param props -CcfCallMuteIconProps
 * @returns call mute svg icon
 * @example - <CcfCallMuteIcon/>
 */
export function CcfCallMuteIcon(props: CcfCallMuteIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Mask">
    <g id="Group_119237" data-name="Group 119237" transform="translate(0.907 0.5)">
      <path id="mic" d="M101.286,12.922a2.937,2.937,0,0,0,2.937-2.937V2.937a2.937,2.937,0,0,0-5.874,0V9.985A2.937,2.937,0,0,0,101.286,12.922Zm4.112-4.7V9.985a4.111,4.111,0,1,1-8.223,0V8.223H96V9.985a5.287,5.287,0,0,0,4.7,5.254v2.382H98.349V18.8h5.874V17.621h-2.349V15.239a5.287,5.287,0,0,0,4.7-5.254V8.223Z" transform="translate(-92.118 0)"/>
      <line id="maskLine1" data-name="Line 1" x1="18.185" y2="18.812" transform="translate(0 0.188)" fill="none" stroke="#000" strokeWidth="1"/>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfCallMuteIcon;
